<template>
    <div class="filter-actions">
        <button class="btn btn-ghost btn-sm" type="button" :disabled="downloading" @click="downloadCSV">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v11M7 10l5 5 5-5M5 20h14" /></svg>
            {{ downloading ? "Preparing…" : "Download CSV" }}
        </button>
    </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { Message } from "element-ui";
import { useUrlFilters } from "../../composables/useUrlFilters";
import { saveTextAsFile } from "../../helpers/saveTextasFile";
import { getCustomersCSV } from "../../api/rest";

const props = defineProps({
    locations: {
        type: Array,
        default: () => [],
    },
    experiences: {
        type: Array,
        default: () => [],
    },
});

const filterStore = useUrlFilters(
    () => props.locations,
    () => props.experiences,
);

const downloading = ref(false);

const downloadCSV = async () => {
    try {
        downloading.value = true;
        const filter = { ...filterStore.filters.value, limit: undefined };
        const result = await getCustomersCSV(filter);
        saveTextAsFile(result, "customer_data.csv", "csv");
    } catch (e) {
        Message.error({ message: `Could not export CSV: ${e.message}` });
    } finally {
        downloading.value = false;
    }
};
</script>

<style scoped>
.filter-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
